export function createNumberArray(start: number, end: number): number[] {
  const result: number[] = [];
  for (let i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
}

export function createPaginationArray(start: number, end: number, active: number, range: number): string[] {
  let pages: string[] = [];
  for (let i = start; i < end; i++) {
    if ( (i == 0) ||
      (
        (
          (i < active + range / 2 ) &&
          (i > active - range / 2)
        ) ||
        (active < range / 2 && i < range) ||
        (active > end - range / 2  && i > end - range -1 )
      ) ||
      (i == end - 1)
    ) {
      pages.push((i + 1).toString());
    } else if (
      (i == active - Math.round( range / 2)) ||
      (i == active + Math.round( range / 2)) ||
      ((i == active + range) && (active < Math.round(range / 2))) ||
      ((i == end - active) && (active > end - Math.round(range / 2)))
    ) {
      pages.push("...");
    }
  }
  return pages;
}
